/**
 * Route for `bigcommerce-integration-via-webhook`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BigcommerceIntegrationViaWebhookPage } from "../features/bigcommerce-integration-via-webhook/BigcommerceIntegrationViaWebhookPage";

export const bigcommerceIntegrationViaWebhookRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/bigcommerce-integration-via-webhook",
	component: BigcommerceIntegrationViaWebhookPage,
});

export default bigcommerceIntegrationViaWebhookRoute;
